import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { Button } from 'ui-components/components/button';

import { DiscountModal } from './discount-modal';
import { DiscountPropType } from '../../../../../prop-types/discount';
import { emptyArray } from 'ui-components/default-props/empty';
import FormattedCurrency from '../../../../../components/formatted-currency/container';
import { useModal } from '../../../../../hooks/use-modal';
import { USD } from '../../../../../constants/currency-codes';

import style from './style.module.less';
import messages from './messages';

const DiscountField = ({ discounts = emptyArray }) => {
  const { close, isOpen, open } = useModal();
  const hasDiscounts = discounts.length;

  if (!hasDiscounts) {
    return null;
  }

  const discountsTotal = discounts.reduce((acc, curr) => {
    return acc + curr.amount.value;
  }, 0);
  const currencyCode = discounts[0]?.amount?.code || USD;

  return (
    <div>
      <label className={style['currency-field-label']} htmlFor='currency-field-content'>
        <FormattedMessage {...messages.orderDiscountLabel} />
      </label>
      <div className={style['currency-field-container']}>
        <div className={style['currency-field-content']} id='currency-field-content'>
          <FormattedCurrency currencyCode={currencyCode} value={discountsTotal} />
        </div>
        <Button onClick={open} theme='link'>
          <FormattedMessage {...messages.orderDiscountDetails} />
        </Button>
      </div>
      {isOpen && <DiscountModal discounts={discounts} onClose={close} />}
    </div>
  );
};

DiscountField.propTypes = {
  discounts: PropTypes.arrayOf(DiscountPropType),
};

export { DiscountField };
